import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import diagnosticBackground from '../assets/diagnostic/diagnostic-background.png';
import diagnosticPortal from '../assets/diagnostic/diagnostic-portal.png';
import './DiagnosticIntro.css';

const DIAGNOSTIC_SAGE = '/heroes/sage/Feiticeiro%20Professor%20e%20Coruja%20M%C3%A1gica.png';
const DIAGNOSTIC_SESSION_KEY = 'mte:diagnostic:session:v1';
const SPEECH_LINES = [
  'Je serai ton guide pendant toute cette aventure.',
  'Aujourd’hui, nous allons découvrir tes pouvoirs !',
  'Pour cela, tu vas faire quelques petites activités. Prends ton temps… fais de ton mieux.',
  'Et maintenant… voyons quels pouvoirs se cachent en toi !',
];

export default function DiagnosticIntro(): JSX.Element {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [speechIndex, setSpeechIndex] = useState(0);
  const childId = searchParams.get('childId');
  const isLastSpeech = speechIndex === SPEECH_LINES.length - 1;

  const startDiagnostic = () => {
    // The intro is already complete on this screen. Seed a fresh diagnostic
    // session in question mode so the questions route does not replay the old
    // internal intro (which could leave the user on an apparently blank screen).
    try {
      window.localStorage.setItem(
        DIAGNOSTIC_SESSION_KEY,
        JSON.stringify({
          childId: childId ?? null,
          currentIdx: 0,
          answeredCompetences: [],
          activitiesIds: [],
          phase: 'question',
          savedAt: Date.now(),
        }),
      );
    } catch {
      // Storage can be unavailable in private/restricted browser contexts.
      // Navigation must still continue.
    }

    const suffix = childId ? `?childId=${encodeURIComponent(childId)}` : '';
    navigate(`/enfant/diagnostic/questions/${suffix}`);
  };

  const nextSpeech = () => {
    setSpeechIndex((current) => Math.min(current + 1, SPEECH_LINES.length - 1));
  };

  return (
    <main className="diagnostic-intro" aria-label="Introduction au diagnostic">
      <img
        className="diagnostic-intro__background"
        src={diagnosticBackground}
        alt=""
        aria-hidden="true"
      />

      <div className="diagnostic-intro__portal-layer" aria-hidden="true">
        <img
          className="diagnostic-intro__portal diagnostic-intro__portal--glow"
          src={diagnosticPortal}
          alt=""
        />
        <img
          className="diagnostic-intro__portal diagnostic-intro__portal--main"
          src={diagnosticPortal}
          alt=""
        />
      </div>

      <div className="diagnostic-intro__sage" aria-label="Sábio, guide du parcours">
        <div className="diagnostic-intro__sage-art">
          <img src={DIAGNOSTIC_SAGE} alt="Le Sábio avec sa chouette" />
        </div>
      </div>

      <section className="diagnostic-intro__speech" aria-live="polite">
        <div className="diagnostic-intro__bubble" key={speechIndex}>
          <span>{SPEECH_LINES[speechIndex]}</span>
          {!isLastSpeech && (
            <button
              className="diagnostic-intro__next"
              type="button"
              onClick={nextSpeech}
              aria-label="Phrase suivante"
            >
              →
            </button>
          )}
        </div>

        {isLastSpeech && (
          <button className="diagnostic-intro__continue" type="button" onClick={startDiagnostic}>
            Commencer
          </button>
        )}
      </section>
    </main>
  );
}
